import Icon_Point from "../../../assets/png/Icon_Point.png";
const NzOrchardisedFeatures = () => {
    return (
        <div className="bg-white pt-[20px] pb-[45px]">
            <div className="custom-container px-[30px] text-start mx-auto ">
                <div className="max-w-[1200px]  mx-auto">
                    <div className="kuunari-bold text-[30px] leading-[71px] text-center mb-[20px] ">Our Orchardised kitset is specifically designed for our eTuatara vehicle.</div>

                    <div className="self-center mt-11 text-xl font-medium leading-8 text-center text-stone-500 max-md:mt-10 max-md:max-w-full">
                        <p>
                            This unique vehicle was designed in New Zealand for the horticultural market to enable easy unobstructed access under kiwifruit canopies and general fruit tree orchards, but  it is also perfect for other horticultural work as well as  market gardens and other maintenance jobs tasks where a “go anywhere”, low-profile vehicle that can carry and tow substantial weights is a great option.
                        </p>
                        <br />
                        <br />
                        {/* <p>
                            The high roof and standard ROPS (roll over protection system) have been replaced with a shoulder height roll over bar and low profile windscreen.
                        </p>
                        <br />
                        <br /> */}
                        <p>
                            The Orchardised eTuatara provides easy walk through access that makes "on and off" work quick and simple.  Just like our other vehicles, its ability to carry and tow  plenty of weight makes this vehicle  superior to other horticultural vehicles,  and being  electric,  it’s cheap to run and maintain, and there are no emissions,  which is great for  the planet.
                        </p>
                        <br />
                        <br />
                        <p>
                            Configuring an Orchardised eTuatara requires the purchase of a standard eTuatara and then we supply an Orchardising kit as an accessory.  Once the cabin is removed, the Orchardising kit is installed in its place.   The kitset comes with a half sized acrylic windscreen, modified seat mountings and lap belts.  And of course, it’s possible to reinstate the full cabin configuration at any time, should the role of the vehicle be changed.
                        </p>
                    </div>

                </div>
            </div>
        </div>
    );
};
export default NzOrchardisedFeatures;
